import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

// import Vuetify from 'vuetify/lib'

import colors from 'vuetify/lib/util/colors'
// import './webfontloader'

Vue.use(Vuetify);
import en from 'vuetify/lib/locale/en'
import de from 'vuetify/lib/locale/de'

export default new Vuetify({
    lang: {
        locales: {en, de},
    },
    theme: {
        dark: false,
        themes: {
            light: {
                // primary: '#344955',
                // secondary: '#F9AA33',
                // tertiary: '#232F34',
                // quaternary: '#4A6572',
                // gridtoolbar: '#90A4AE',
                primary: '#131537',
                secondary: '#000000',
                tertiary: '#232F34',
                quaternary: '#4A6572',
                gridtoolbar: '#131537',
                flamingo: '#E1634D',
                tht_color: '#1A237E',
                tht_light_color: '#8C9EFF',
                smd_color: '#f4C218',
                smd_light_color: '#FFE082',
                scheduled: '#f4C218',
                unscheduled: '#8C9EFF',
                edit_icon: '#448AFF',
                information_icon: '#448AFF'
            },
            dark: {
                primary: '#50778D',
                secondary: '#0B1C3D',
                accent: '#204165',
            },
        },
    },
    breakpoint: {
    mobileBreakpoint: 'md'
  },
});
